import { Component, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'cc-used-domain-modal',
  templateUrl: 'used-domain-modal.component.html',
  styleUrls: ['used-domain-modal.component.scss'],
})
export class UsedDomainModalComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  @Input() domain: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  createWorkspace() {
    this.activeModal.close({
      createWorkspace: true,
    });
  }

  joinExistingWorkspace() {
    this.activeModal.close({
      joinExistingWorkspace: true,
    });
  }
}
